export {default} from './CheckboxesPanel_component';


// WEBPACK FOOTER //
// ./components/qual/Table/TableHeader/TableHeaderCell/TableColumnFilter/FilterTypes/MultipleChoice/CheckboxesPanel/index.js